import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "../services/api";
import {
  GiftCardCatalog,
  RedemptionModal,
  RedemptionHistory,
  GiftCard,
} from "@/components/gift-cards";

// Fetch user's points balance
async function fetchBalance(): Promise<number> {
  const response = await api.get<{ success: boolean; data: { balance: number } }>(
    "/deposits/balance"
  );
  return response.data.data.balance;
}

export default function RedeemPage() {
  const [selectedGiftCard, setSelectedGiftCard] = useState<GiftCard | null>(null);

  // Fetch user's points balance
  const { data: balance, isLoading: balanceLoading } = useQuery({
    queryKey: ["points", "balance"],
    queryFn: fetchBalance,
  });

  const handleSelectGiftCard = (giftCard: GiftCard) => {
    setSelectedGiftCard(giftCard);
  };

  const handleCloseModal = () => {
    setSelectedGiftCard(null);
  };

  return (
    <div>
      {/* Header Section */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-100 mb-2">Redeem Points</h1>
        <p className="text-gray-400">
          Exchange your earned points for gift cards from popular brands
        </p>
      </div>

      {/* Points Balance Card */}
      <div className="card mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-sm font-medium text-gray-400 mb-1">Your Points Balance</p>
            {balanceLoading ? (
              <div className="animate-pulse bg-dark-700 h-10 w-32 rounded"></div>
            ) : (
              <p className="text-4xl font-bold text-primary-300">
                {balance?.toLocaleString() ?? 0}
                <span className="text-lg font-normal text-gray-400 ml-2">points</span>
              </p>
            )}
          </div>
          <Link to="/deposit" className="btn btn-primary">
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            Add Points
          </Link>
        </div>
      </div>

      {/* Gift Card Catalog */}
      <div className="mb-12">
        <GiftCardCatalog
          onSelect={handleSelectGiftCard}
          selectedId={selectedGiftCard?.id}
        />
      </div>

      {/* Redemption History */}
      <div className="border-t border-dark-border pt-8">
        <RedemptionHistory />
      </div>

      {/* Redemption Modal */}
      {selectedGiftCard && (
        <RedemptionModal
          giftCard={selectedGiftCard}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}
